import { BrowserRouter, Routes, Route, Link } from 'react-router-dom'
import { Home } from './home';
import { Scribble } from './scribble/scribble';
import 'tldraw/tldraw.css'

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/whiteboard" element={
                    <Scribble />
                } />
            </Routes>
        </BrowserRouter>
    )
}
export default App;
